import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';

function PrivacyDialog({ showPrivacyDialog, handlePrivacyClose, privacyUrl }) {
  // State to hold the fetched content
  const [htmlContent, setHtmlContent] = useState('');
  // States for loading and error handling for a better UX
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchHTML() {
      setIsLoading(true);
      setError(null);
      try {
        const response = await fetch(privacyUrl);

        // 2. fetch doesn't throw an error for bad HTTP status, so we check it manually
        if (!response.ok) {
          throw new Error(`Fetch failed: ${response.statusText}`);
        }

        // 3. Get the response body as text (since it's HTML)
        const html = await response.text();
        setHtmlContent(html);

      } catch (err) {
        setError('Failed to load content.');
        console.error('Error fetching HTML:', err);
      } finally {
        setIsLoading(false);
      }
    }

    // This logic remains the same: only fetch when opened and if content doesn't already exist
    if (showPrivacyDialog && !htmlContent) {
      fetchHTML();
    }
  }, [showPrivacyDialog, privacyUrl, htmlContent]);

  // If the dialog shouldn't be shown, render nothing.
  if (!showPrivacyDialog) {
    return null;
  }

  // This rendering logic also remains identical
  return (
    <div className="dialog-right-overlay">
      <div className="dialog">
        <button className="close-btn" onClick={handlePrivacyClose}><FontAwesomeIcon icon={faClose} /></button>
        
        {isLoading && <div>Loading...</div>}
        {error && <div>{error}</div>}
        
        {!isLoading && !error && (
            <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        )}
      </div>
    </div>
  );
}

export default PrivacyDialog;
